import { Component, Input } from '@angular/core';

/**
 * Drop-in replacement for the abandoned `angular-font-awesome` package.
 * Renders <i class="fa fa-{name} fa-{animation} fa-{size}"></i>.
 */
@Component({
  selector: 'fa',
  template: '<i [ngClass]="classes"></i>',
})
export class FaComponent {
  @Input() name: string = '';
  @Input() animation: string = '';
  @Input() size: string = '';

  get classes(): string[] {
    const c = ['fa'];
    if (this.name) { c.push('fa-' + this.name); }
    if (this.animation) { c.push('fa-' + this.animation); }
    if (this.size) { c.push('fa-' + this.size); }
    return c;
  }
}
